import React, { useState } from "react";
import AdminDashboard from "./components/AdminDashboard"; // Updated import path
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  // eslint-disable-next-line
  const [currentOpportunity, setCurrentOpportunity] = useState(null);

  // Function to handle viewing the opportunity
  const handleViewOpportunity = (opportunityId) => {
    // Logic to set the current opportunity, e.g., fetching details from an API or state
    console.log("Viewing opportunity with ID:", opportunityId);
    setCurrentOpportunity(opportunityId);
  };

  return (
    <div>
      {/* Pass down the handleViewOpportunity to AdminDashboard */}
      <AdminDashboard onViewOpportunity={handleViewOpportunity} />
      <ToastContainer />
    </div>
  );
}

export default App;
